import { Icon } from '@flatfile/baseline'

type MenuItemProps = {
  icon: string
  label: string
  hasChevron?: boolean
  isDestructive?: boolean
  onClick?: () => void
}

export function MenuItem({
  icon,
  label,
  hasChevron,
  isDestructive,
  onClick,
}: MenuItemProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick?.()
  }

  return (
    <div
      className='flex items-center justify-between px-3 py-2 hover:bg-[#e0e1e6] rounded-lg cursor-pointer group transition-colors'
      onClick={handleClick}
    >
      <div className='flex items-center gap-3'>
        <div
          className={`${isDestructive ? 'text-[#dd4425]' : 'text-[#64748b]'}`}
        >
          <Icon name={icon} size={16} />
        </div>
        <span
          className={`text-sm font-medium ${isDestructive ? 'text-[#dd4425]' : 'text-[#1b1b1e]'}`}
        >
          {label}
        </span>
      </div>
      {hasChevron && (
        <Icon
          name='obvious-chevron-right'
          size={16}
          className='text-[#838383]'
        />
      )}
    </div>
  )
}
